import React from "react";
import RequesterDashboard from "./RequesterDashboard";

const ClientDashboard = () => (
  <RequesterDashboard
    title="Mon espace client"
    subtitle="Suivez vos demandes d'intervention NGL SERVICES"
    showTenant={false}
    role="client"
  />
);

export default ClientDashboard;
